import { render } from "./CopyrightComponent.vue?vue&type=template&id=6b6fba15"
import script from "./CopyrightComponent.vue?vue&type=script&lang=js"
export * from "./CopyrightComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\tft prod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__